export const isAuthenticated = (state) => {
 
if(window.location.toString().includes('user') || window.location.toString().includes('learning')){

  let userDetails=  localStorage.getItem('userDetails');
  if(userDetails){
    userDetails=JSON.parse(userDetails)
  }
  
 

  if(userDetails?.jwtToken){
        return true;
  } 
}else{
    return ;
}
return ;
 
};
